/**
 * Fixed platform → series-colour binding.
 *
 * Colour identifies the platform, not its position on screen: a lookup keyed by platform
 * name, never an index into whatever array the caller happens to be rendering. Indexing
 * would repaint the survivors every time a filter or sort changes which platforms are
 * currently visible - the same platform must always land on the same CSS variable.
 */
export const PLATFORM_SERIES_ORDER: readonly string[] = [
  'dv360',
  'meta_ads',
  'google_ads',
  'cm360',
  'youtube_ads',
  'tiktok_ads',
  'linkedin_ads',
  'microsoft_ads',
];

export const OTHER_SERIES_VAR = 'var(--series-other)';

const PLATFORM_TO_SERIES_VAR: ReadonlyMap<string, string> = new Map(
  PLATFORM_SERIES_ORDER.map((platform, index) => [platform, `var(--series-${index + 1})`]),
);

/**
 * A ninth or unrecognised platform folds into `OTHER_SERIES_VAR` rather than a generated
 * hue - the palette is validated for exactly these eight slots, so anything beyond them has
 * no colour we can vouch for.
 */
export function seriesVarForPlatform(platform: string): string {
  return PLATFORM_TO_SERIES_VAR.get(platform) ?? OTHER_SERIES_VAR;
}
